import _ from 'lodash'
import DataTypes, { AUXILIARY_TYPES } from 'constants/DataTypes'
import { conformToMask } from 'react-text-mask'
import { deviceIdMask } from 'constants/DeviceIdMask'
import { DEFAULT_SERIAL_NUMBER } from 'constants/DefaultMicaValues'

const order = [
  DataTypes.THERMAL_INDICATOR,
  DataTypes.VENTILATION_INDICATOR,
  DataTypes.MOLD_INDICATOR,
  DataTypes.COVID_19,
  DataTypes.IAQ,
  DataTypes.GO_IAQS,
  DataTypes.GO_IAQS_DOMINANT,

  DataTypes.TEMPERATURE,
  DataTypes.HUMIDITY,
  DataTypes.CO2,
  DataTypes.FORMALDEHYDE,
  DataTypes.VOCS,
  DataTypes.VOCS_INDEX,
  DataTypes.PM1,
  DataTypes.PM25,
  DataTypes.PM4,
  DataTypes.PM10,
  DataTypes.CO,
  DataTypes.O3,
  DataTypes.NO2,

  DataTypes.NOISE,
  DataTypes.LIGHT,

  DataTypes.RADON,
  DataTypes.RADIANT_TEMPERATURE,
  DataTypes.NOX
]

const sortDataByOrder = data => _.sortBy(data, obj => _.indexOf(order, obj.type))

export const getDataSorted = (system, filter = []) => {
  return sortDataByOrder(system.data).filter(data => {
    return !AUXILIARY_TYPES.has(data.type) && !filter.includes(data.type)
  })
}

// Converts an Immutable.js collection (List/Map) into a plain JS array.
// Safe with null/undefined (returns []) and already-plain arrays (passthrough).
// Replaces the duplicated `collection.toArray().map(x => x.toJS())` idiom
// scattered across containers.
export const immutableToArray = collection => {
  if (!collection) return []
  if (Array.isArray(collection)) return collection

  return collection.toArray().map(item => item.toJS())
}

// Turns a MAC address ("30:C9:22:60:22:80") into the device ID users see ("30C9-2260-2280").
// Uses the same mask as the device ID inputs, so any separator (or none) in the MAC works.
export const formatDeviceId = macAddress => {
  if (!macAddress) return ''

  return conformToMask(macAddress, deviceIdMask, { guide: false }).conformedValue
}

// Drops the ":" and "-" separators so an ID matches however the user types it.
const compactDeviceId = value => value.replace(/[:-]/g, '')

// True when the search text matches the device name, its ID or its serial number.
// The ID matches with or without separators ("30C9-2260", "30c92260", "30:C9:22").
// The UNKNOWN_SN placeholder is skipped so "unknown" does not match every device without one.
export const matchesDeviceSearch = (system, search) => {
  const query = search.trim().toLowerCase()
  if (!query) return true

  const deviceId = formatDeviceId(system.macAddress).toLowerCase()
  const serialNumber =
    system.serialNumber === DEFAULT_SERIAL_NUMBER ? '' : system.serialNumber?.toLowerCase()
  const compactQuery = compactDeviceId(query)

  return (
    !!system.name?.toLowerCase().includes(query) ||
    deviceId.includes(query) ||
    (compactQuery !== '' && compactDeviceId(deviceId).includes(compactQuery)) ||
    !!serialNumber?.includes(query)
  )
}
